import React from 'react'
import styled from 'styled-components'
import { I18n } from 'react-redux-i18n'
import { Row, Col, Input } from 'reactstrap'

const Passenger = styled.div`
  cursor: pointer;
  border-radius: 6px;
  padding: 7px;
  display: inline-block;
  min-width: 250px;
  width: 100%;
  border: 1px solid rgba(100, 100, 100, 0.1);
  box-shadow: 0px 0px 12px -2px rgba(50, 50, 50, 0.1);
  background-color: #fff;
  transition: 0.3s;

  &:not(:last-child) {
    margin-bottom: 10px;
    margin-right: 10px;
    width: 100%;
  }

  &:hover {
    background-color: rgba($color: $primary, $alpha: 0.05);
    box-shadow: 0px 3px 13px -2px rgba($color: #333, $alpha: 0.1);
    transform: translateY(-2px);
  }

  .row {
    padding: 6px;
  }

  input {
    background-color: transparent !important;
    padding: 0;
    padding-left: 5px;
    /* border: 0; */
    background-color: transparent;
    /* border-top: 0;
    border-left: 0;
    border-right: 0;
    border-radius: 0; */
    margin-left: 5px;
    /* width: 80%; */
    display: inline;
    &:focus {
      outline: 0px !important;
      -webkit-appearance: none;
      box-shadow: none !important;
    }
    &:read-only {
      background-color: transparent !important;
      border: 0;
    }
  }
`

export default function PassegerCard(props) {
  const { passenger, handleClick, editMode } = props
  const { name, surnames, lastName, birthdate, passport, type, idDocument } = passenger

  return (
    <Passenger onClick={() => handleClick && handleClick(passenger)}>
      {!editMode ? (
        <>
          <Row>
            <Col sm='4'>
              <strong>{I18n.t('Nombres')}:</strong>
            </Col>
            <Col sm='8'>{name}</Col>
          </Row>
          <Row>
            <Col sm='4'>
              <strong>{I18n.t('Apellidos')}:</strong>
            </Col>
            <Col sm='8'>{surnames || lastName}</Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col sm='4'>
              <strong>{I18n.t('Nombres')}:</strong>
            </Col>
            <Col sm='8'>
              <Input className='form-control' type='text' name='passenger.name' defaultValue={name} />
            </Col>
          </Row>
          <Row>
            <Col sm='4'>
              <strong>{I18n.t('Apellidos')}:</strong>
            </Col>
            <Col sm='8'>
              <Input className='form-control' type='text' name='passenger.surnames' defaultValue={surnames || lastName} />
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col sm='4'>
          <strong>{I18n.t('passenger.birthdate')}:</strong>
        </Col>
        <Col sm='8'>{birthdate}</Col>
      </Row>
      <Row>
        <Col sm='4'>
          <strong>{I18n.t('passenger.passport')}:</strong>
        </Col>
        <Col sm='8'>{passport || idDocument}</Col>
      </Row>
      {type && (
        <Row>
          <Col sm='4'>
            <strong>{I18n.t('passenger.type')}:</strong>
          </Col>
          <Col sm='8'>{I18n.t(`management.${type || ''}`)}</Col>
        </Row>
      )}
    </Passenger>
  )
}
